import React from 'react'
import styles from './MicrositePrePublishChecklist.module.css'
import { CheckCircle2, AlertCircle } from 'lucide-react'

/**
 * MicrositePrePublishChecklist
 * Readiness checklist shown on MicrositePublish before the user
 * hits Publish — domain verified, SSL active, no blocking drafts.
 *
 * Usage:
 *   <MicrositePrePublishChecklist
 *     items={[
 *       { label: 'Primary domain verified', ok: domain?.dnsVerified },
 *       { label: 'SSL certificate active', ok: domain?.sslStatus === 'ACTIVE' },
 *       { label: 'No draft-only landing sections', ok: true }
 *     ]}
 *   />
 */
const MicrositePrePublishChecklist = ({ items = [] }) => (
    <div className={styles.wrap}>
        <div className={styles.label}>Before you publish</div>
        <ul className={styles.list}>
            {items.map((item, idx) => (
                <li key={idx} className={styles.item}>
                    {item.ok ? (
                        <CheckCircle2 size={15} className={styles.iconOk} />
                    ) : (
                        <AlertCircle size={15} className={styles.iconWarn} />
                    )}
                    <span className={item.ok ? styles.textOk : styles.textWarn}>{item.label}</span>
                </li>
            ))}
        </ul>
    </div>
)

export default MicrositePrePublishChecklist